import { useTranslation } from "react-i18next";
import { RootState } from "../../store/root-reducer";
import { connect, useSelector } from "react-redux";
import { ContactServiceFileTypeSteps } from "./types";
import FieldBlock from "../../components/CreateClaim/FieldBlock";
import { useMemo } from "react";
import { ChildFlatItem, FlatItem, ApiChildFlatItem } from "../../types/general";
import { mapApiChildFlatData } from "../../store/user/helpers";

function ReviewContactService() {
  const { t } = useTranslation();
  const { customerDetails, purchaseDetails, documents, claimItemDamage } =
    useSelector((state: RootState) => state.contactService);
  const {
    damageTypes,
    specificDamages,
    specificLocations,
    actionsTaken,
    howDidOccur,
  } = useSelector((state: RootState) => state.user.claimOptions);

  const getLabel = (id, options: FlatItem[] = []) => {
    return options.find((opt) => opt.id == id)?.name || id;
  };

  const getSpecificDamageLabel = (id, options: ChildFlatItem[] = []) => {
    // @ts-ignore
    return options?.find((opt) => opt.id == id)?.name || id;
  };

  return (
    <div className="space-y-6">
      <div>
        <div className="bg-[#EBEEEF]  text-black font-semibold min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
          {t(ContactServiceFileTypeSteps.CUSTOMER_DETAILS)}
        </div>
        <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
          <FieldBlock label="Name" value={customerDetails.name} />
          <FieldBlock label="Email" value={customerDetails.email} />
          <FieldBlock label="Phone" value={customerDetails.phone} />
          <FieldBlock label="Address" value={customerDetails.address} />
          <FieldBlock label="City" value={customerDetails.city} />
          <FieldBlock label="State" value={customerDetails.state} />
          <FieldBlock label="Zip code" value={customerDetails.zip_code} />
        </div>
      </div>
      <div>
        <div className="bg-[#EBEEEF]  text-black font-semibold min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
          {t(ContactServiceFileTypeSteps.PURCHASE_DETAILS)}
        </div>
        <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
          <FieldBlock label="Invoice" value={documents.invoice?.[0]} image />
          <FieldBlock label="Invoice Number" value={purchaseDetails.invoice} />
          <FieldBlock
            label="Date of Purchase"
            value={purchaseDetails.date_of_purchase}
            date
          />
          <FieldBlock label="Store Name" value={purchaseDetails.store_name} />
          <FieldBlock label="Store Phone" value={purchaseDetails.store_phone} />
          <FieldBlock
            label="Store Address"
            value={purchaseDetails.store_address}
          />
          <FieldBlock label="Store City" value={purchaseDetails.store_city} />
          <FieldBlock label="Store State" value={purchaseDetails.store_state} />
          <FieldBlock
            label="Store Zip code"
            value={purchaseDetails.store_zip}
          />
          <FieldBlock
            label="Were any items exchanged"
            value={purchaseDetails.were_any_items_exchanged}
          />
        </div>
      </div>
      <div>
        <div className="bg-[#EBEEEF]  text-black font-semibold min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
          {t(ContactServiceFileTypeSteps.DAMAGE_DETAILS)}
        </div>
        <div className="space-y-4 shadow-sm bg-white p-2">
          {claimItemDamage?.map((item, index) => (
            <div key={index}>
              <h5 className="font-semibold mb-2">
                {t("Damage")} {index + 1}
              </h5>
              <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
                <FieldBlock
                  label="Damage Category"
                  value={getLabel(item.damage_category, damageTypes)}
                />
                <FieldBlock
                  label="Specific Damage"
                  // @ts-ignore
                  value={getSpecificDamageLabel(
                    item.specific_damage,
                    specificDamages
                  )}
                />
                <FieldBlock
                  label="Damage Area"
                  value={getLabel(item.damage_area, specificLocations)}
                />
                <FieldBlock
                  label="When did you notice the damage"
                  value={item.when_did_you_notice_the_damage}
                  date
                />
                <FieldBlock
                  label="How did it happen"
                  value={getLabel(item.how_did_it_happen, howDidOccur)}
                />
                <FieldBlock
                  label="Did you take any steps to remedy"
                  value={getLabel(
                    item.did_you_take_any_steps_to_remedy,
                    actionsTaken
                  )}
                />
                <FieldBlock label="Note" value={item.note} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  claim: state?.claim || {},
});

export default connect(mapStateToProps)(ReviewContactService);
